<template>
    <div>
        <SingleReportHeader :dataFrom="table.params" @search="searchData" :toPdf="toPdf" :excelShow="false"></SingleReportHeader>
        <Collapse v-model="table.name">
            <Panel v-for="(item, index) in table.list" :key="index" :name="`${index}`">
                {{ item.name }}
                <template v-if="item.showImage != true">
                    <div slot="content">
                        <Table style="margin-top: 10px" border size="large" :columns="item.column" :data="index == 5 ? item.data : table.data"></Table>
                    </div>
                </template>
                <template v-else>
                    <div slot="content">
                        <template v-for="temp in item.data">
                            <div style="width: 50%; display: inline-block; position: relative">
                                <div style="position: absolute; font-weight: bold; font-size: 18; padding-left: 10px">
                                    {{ temp.title }}
                                </div>
                                <ve-line :data="temp.data" :settings="temp.settings" :colors="item.options" :extend="item.extend" :ref="temp.ref"></ve-line>
                            </div>
                        </template>
                    </div>
                </template>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import { TransTopReq } from '@/api/admin/risk'
import SingleReportHeader from './components/single_report_header.vue'
export default {
    name: 'BriefDaily',
    components: { SingleReportHeader },
    data() {
        return {
            loading: false,
            timestamp: 0,
            calcMap: {},
            table: {
                name: ['0', '1', '2', '3', '4', '5', '6'],
                data: [],
                mPlatData: [],
                mPayData: [],
                params: {
                    platid: 0,
                    app_id: 0,
                    dataTime: this.getCurrentZeroDay()
                },
                list: [
                    {
                        name: '数据概况',
                        column: [
                            this.getColumnFirst(),
                            {
                                key: 'pay_sum',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '总转入金额', '转入金额')
                            },
                            {
                                key: 'r_pay_rate',
                                align: 'center',
                                minWidth: 60,
                                renderHeader: (h, params) => this.renderHeader(h, '大R占比', '显示对比的大R转入金额/转入金额'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'new_win_sum',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '营收金额', '今日转入-今日转出+昨日余额-今日余额')
                            },
                            {
                                key: 'new_win_rate',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => {
                                    if (params.row.new_win_rate == -1 && params.row.type == 0) {
                                        return h('span', '--')
                                    } else {
                                        return this.rColItem(h, params)
                                    }
                                },
                                renderHeader: (h, params) => this.renderHeader(h, '营收比', '营收金额 / 转入金额')
                            },
                            {
                                key: 'pay_ave',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, 'ARPPU', '转入金额 / 转入人数')
                            },
                            {
                                key: 'active_user_num',
                                align: 'center',
                                minWidth: 50,
                                renderHeader: (h, params) => this.renderHeader(h, '活跃人数', '当天登录玩家人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'pay_user_num',
                                align: 'center',
                                minWidth: 60,
                                renderHeader: (h, params) => this.renderHeader(h, '转入人数', '当天成功转入人数，去重'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'put_pay_rate',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '转入转出比', '转出人数/转入人数')
                            },
                            {
                                key: 'pay_winner_rate',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '转入赢家数占比', '转入玩家赢的人数/(转入玩家赢的人数+转入玩家输的人数);不统计高倍游戏')
                            },
                            {
                                key: 'money_win_rate',
                                align: 'center',
                                minWidth: 55,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '实钱赢家数占比', '今日转出+今日余额-今日转入-昨日余额')
                            },
                            {
                                key: 'new_ci_ri_pay_rate',
                                align: 'center',
                                minWidth: 60,
                                renderHeader: (h, params) => this.renderHeader(h, '新增转入次日复充', '显示对比的新增转入次日复充'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'ci_ri_pay_rate',
                                align: 'center',
                                minWidth: 60,
                                renderHeader: (h, params) => this.renderHeader(h, '平台转入次日复充', '显示对比的平台转入次日复充'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'online_pay_rate',
                                align: 'center',
                                minWidth: 60,
                                render: (h, params) => this.rColItem(h, params),
                                renderHeader: (h, params) => this.renderHeader(h, '线上转入成功率', '显示对比的线上转入成功率')
                            }
                        ],
                        data: []
                    },
                    {
                        name: '活跃概况',
                        column: [
                            this.getColumnFirst(),
                            {
                                key: 'pay_user_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '转入人数', '显示转入人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'pay_bet_user_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '充投人数', '转入人数+投注人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'bet_pay_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '投注转入比', '【投注金额】/【转入金额】'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'ci_ri_login_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '转入用户次日留存', '显示转入用户次日留存'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'ci_ri_pay_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '转入用户次日复充', '显示转入用户次日复充占比'),
                                render: (h, params) => this.rColItem(h, params)
                            }
                        ],
                        data: []
                    },
                    {
                        name: '新增概况',
                        column: [
                            this.getColumnFirst(),
                            {
                                key: 'new_user_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增人数', '当天新增玩家人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'new_user_pay_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增转入人数', '当天新增且转入的人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'zhuan_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增转化率', '显示当前日期的新增转入人数 / 新增人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'new_ci_ri_pay_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增转入用户次日复充', '显示当前日期的新增转入用户次日复充'),
                                render: (h, params) => this.rColItem(h, params)
                            }
                        ],
                        data: []
                    },
                    {
                        name: '代理概况',
                        column: [
                            this.getColumnFirst(),
                            {
                                key: 'agent_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '历史代理人数', '显示当前日期的历史代理人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'sub_user_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增代理人数', '显示当前日期的新增代理人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'send_percent_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '佣金发放人数', '显示当前日期的佣金发放人数'),
                                render: (h, params) => {
                                    if (params.row.send_percent_num == -1 && params.row.type == 0) {
                                        return h('span', '-')
                                    } else {
                                        return this.rColItem(h, params)
                                    }
                                }
                            },
                            {
                                key: 'send_percent_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '佣金', '当天收到系统发放的推广奖励金额之和'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'pid_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '代理拉新人数', '显示当前日期的代理拉新人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'first_pay',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '代理拉新首充人数', '显示当前日期的代理拉新首充人数'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'all_money',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '代理拉新首充apru', '显示当前日期的代理拉新首充apru'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'm_moeny_loss_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '佣金转入比', '显示当前日期的佣金金额 / 转入总金额'),
                                render: (h, params) => this.rColItem(h, params)
                            }
                        ],
                        data: []
                    },
                    {
                        name: '活动彩金概况',
                        column: [
                            this.getColumnFirst(),
                            {
                                key: 'pay_online_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '线上活动彩金', '显示当前日期的线上活动彩金'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'c_give_pay_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '线下活动彩金', '显示当前日期的线下活动彩金'),
                                render: (h, params) => this.rColItem(h, params)
                            },
                            {
                                key: 'jackpot_pay_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '彩金转入比', '显示当前日期的彩金转入比'),
                                render: (h, params) => this.rColItem(h, params)
                            }
                        ],
                        data: []
                    },
                    {
                        name: '商户概况',
                        column: [
                            {
                                title: '序号',
                                type: 'index',
                                align: 'center',
                                width: 70
                            },
                            {
                                key: 'general_name',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '商户信息', '商户信息'),
                                render: (h, params) => {
                                    let str = params.row.general_id < 0 ? '合计' : params.row.general_name + '(' + params.row.general_id + ')'
                                    return h('span', str)
                                }
                            },
                            {
                                key: 'pay_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '转入金额', '商户所属玩家当天总转入金额'),
                                render: (h, params) => h('span', this.getCustomFixed(params.row.pay_sum / 10000))
                            },
                            {
                                key: 'pay_put_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '充提差', '充提差'),
                                render: (h, params) => h('span', this.getCustomFixed(params.row.pay_put_sum / 10000))
                            },
                            {
                                key: 'new_user_pay_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '新增用户转入人数', '商户所属玩家当天新增并转入的人数')
                            },
                            {
                                key: 'one_pay_rate',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '昨日新增转入次日复充率', '昨日新增转入次日复充率'),
                                render: (h, params) => h('span', this.calcRateItem(params.row.one_pay_rate) + '%')
                            },
                            // {
                            //     key: 'pay_put_rate',
                            //     align: 'center',
                            //     renderHeader: (h, params) => this.renderHeader(h, '充提差转入比', '充提差转入比'),
                            //     render: (h, params) => h('span', this.calcRateItem(params.row.pay_put_rate) + '%'),
                            // },
                            {
                                key: 'y_pay_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '环比转入金额', '环比转入金额'),
                                render: (h, params) => {
                                    let color = this.rCol(1, params.row.y_pay_sum)
                                    return h('span', { style: { color } }, this.getCustomFixed(params.row.y_pay_sum / 10000))
                                }
                            },
                            {
                                key: 'y_pay_put_sum',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '环比充提差', '环比充提差'),
                                render: (h, params) => {
                                    let color = this.rCol(1, params.row.y_pay_put_sum)
                                    return h('span', { style: { color } }, this.getCustomFixed(params.row.y_pay_put_sum / 10000))
                                }
                            },
                            {
                                key: 'y_new_user_pay_num',
                                align: 'center',
                                renderHeader: (h, params) => this.renderHeader(h, '环比新增转入人数', '商户所属玩家（当天 - 昨天）新增并转入的人数'),
                                render: (h, params) => {
                                    let color = this.rCol(1, params.row.y_new_user_pay_num)
                                    return h('span', { style: { color } }, params.row.y_new_user_pay_num)
                                }
                            }
                        ],
                        data: []
                    },
                    {
                        name: '月走势图',
                        column: [],
                        extend: {
                            series: {
                                smooth: false
                            },
                            xAxis: {
                                axisLabel: {
                                    formatter: (val) => {
                                        return `${parseInt(val.slice(6))}`
                                    }
                                }
                            },
                            legend: {
                                right: '20'
                            }
                        },
                        options: ['#32CD32', 'rgb(244, 128, 36)'],
                        data: [
                            {
                                title: '转入用户复充率',
                                settings: {
                                    labelMap: {},
                                    yAxisType: ['percent', 'percent'],
                                    axisSite: { right: ['转入次日复充率'] },
                                    scale: [true, true]
                                },
                                data: {
                                    columns: ['time', '新增次日复充率', '转入次日复充率'],
                                    rows: []
                                },
                                ref: 'brief_line_0'
                            },
                            {
                                title: '转入和营收趋势',
                                settings: {
                                    labelMap: {},
                                    yAxisType: ['normal', 'normal'],
                                    axisSite: { right: ['营收金额'] },
                                    scale: [true, true]
                                },
                                data: {
                                    columns: ['time', '总转入', '营收金额'],
                                    rows: []
                                },
                                ref: 'brief_line_1'
                            },
                            {
                                title: '赢家数占比',
                                settings: {
                                    labelMap: {},
                                    yAxisType: ['percent', 'percent'],
                                    axisSite: { right: ['实钱赢家数占比'] },
                                    scale: [true, true]
                                },
                                data: {
                                    columns: ['time', '转入赢家数占比', '实钱赢家数占比'],
                                    rows: []
                                },
                                ref: 'brief_line_2'
                            },
                            {
                                title: '活跃转入人数趋势',
                                settings: {
                                    labelMap: {},
                                    yAxisType: ['normal', 'normal'],
                                    axisSite: { right: ['转入人数'] },
                                    scale: [true, true]
                                },
                                data: {
                                    columns: ['time', '活跃人数', '转入人数'],
                                    rows: []
                                },
                                ref: 'brief_line_3'
                            },
                            {
                                title: 'ARPPU和和营收Arpu趋势',
                                settings: {
                                    labelMap: {},
                                    yAxisType: ['normal', 'normal'],
                                    axisSite: { right: ['ARPPU'] },
                                    scale: [true, true]
                                },
                                data: {
                                    columns: ['time', '营收arpu', 'ARPPU'],
                                    rows: []
                                },
                                ref: 'brief_line_4'
                            }
                        ],
                        showImage: true
                    }
                ]
            }
        }
    },
    methods: {
        getMaxDay(year, month) {
            let isYear = (0 == year % 4 && 0 != year % 100) || 0 == year % 400
            var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
            daysInMonth[1] = isYear ? 29 : 28
            return daysInMonth[month]
        },
        //获取平台总数据请求
        async searchData() {
            let initStartTime = this.getSecond(this.table.params.dataTime)
            let month = this.table.params.dataTime.getMonth()
            let day = this.table.params.dataTime.getDate()
            let year = this.table.params.dataTime.getFullYear()
            let prevYear = year
            let prevMonth = month - 1
            if (prevMonth < 0) {
                prevMonth = 11
                prevYear--
            }
            let dateMap = {
                tStime: initStartTime, //今天
                tEtime: initStartTime + 24 * 60 * 60 - 1,
                yStime: initStartTime - 24 * 60 * 60, //昨天
                yEtime: initStartTime - 1,
                wStime: initStartTime - 7 * 24 * 60 * 60, //上周本天
                wEtime: initStartTime - 6 * 24 * 60 * 60 - 1,
                mStime: initStartTime - (day - 1) * 24 * 60 * 60 - this.getMaxDay(prevYear, prevMonth) * 24 * 60 * 60, //上月
                mEtime: initStartTime - (day - 1) * 24 * 60 * 60 - 1,
                nStime: initStartTime - day * 24 * 60 * 60
            }
            this.table.data = []
            this.table.list.forEach((item, index) => {
                if (index != this.table.list.length - 1) {
                    item.data = []
                } else {
                    item.data.forEach((el, count) => {
                        el.data.rows = []
                    })
                }
            })
            let timestamp = new Date().getTime()
            let { platid, app_id } = this.table.params
            let params = this.getTransTopParams('GetNewPlatfromData', { platid, app_id, timestamp, stime: 0, etime: 0, limit: 100, page: 1, general: -1, pack_no: -1, min: 100000000, max: -1 }) //平台数据

            //商户信息
            let params5 = this.copyData(params)
            params5.param._func = 'GetPlatformGeneralSumData'
            params5.param._param.stime = dateMap.tStime
            params5.param._param.etime = dateMap.tEtime
            TransTopReq(params5).then((res) => {
                let data = res._param.data || []
                let params6 = this.copyData(params5)
                params6.param._param.stime = dateMap.yStime
                params6.param._param.etime = dateMap.yEtime
                TransTopReq(params6).then((res1) => {
                    let data1 = res1._param.data || []
                    data.forEach((item) => {
                        let id = item.general_id
                        let find = data1.find((el) => el.general_id === item.general_id)
                        item.pay_put_rate = item.pay_sum ? (item.pay_sum - item.put_sum) / item.pay_sum : 0
                        item.y_pay_sum = item.pay_sum
                        item.y_pay_put_sum = item.pay_put_sum
                        item.y_new_user_pay_num = item.new_user_pay_num
                        if (find) {
                            item.y_pay_sum -= find.pay_sum
                            item.y_pay_put_sum -= find.pay_put_sum
                            item.y_new_user_pay_num -= find.new_user_pay_num
                        }
                    })
                    this.table.list[5].data = data
                })
            })

            //本月至筛选数据
            let tMonthParam = this.copyData(params)
            tMonthParam.param._param.stime = dateMap.nStime
            tMonthParam.param._param.etime = dateMap.tStime
            let list = [[], [], [], [], []]

            TransTopReq(tMonthParam).then((res) => {
                let platData = res._param.data || []
                let params9 = this.copyData(tMonthParam) //转入留存
                params9.param._func = 'GetNewPlatformRepeatPayInfo'
                TransTopReq(params9).then((res1) => {
                    let newPayData = res1._param.data
                    let params10 = this.copyData(tMonthParam) //新增转入
                    params10.param._func = 'GetNewPlatfromNewPayInfo'
                    TransTopReq(params10).then((res2) => {
                        let payData = res2._param.data || []
                        for (let i = payData.length - 1; i > 0; i--) {
                            let item = platData[i]
                            let item1 = newPayData[i]
                            let item2 = payData[i]
                            let time = item.time
                            let data = {
                                time,
                                新增次日复充率: item2.ci_ri_pay_rate,
                                转入次日复充率: item1.ci_ri_pay_rate
                            }
                            let data1 = {
                                time,
                                总转入: this.getCustomFixed(item.pay_sum / 10000),
                                营收金额: this.getCustomFixed(item.new_win_sum / 10000)
                            }
                            let data2 = {
                                time,
                                转入赢家数占比: item.pay_winner_rate.toFixed(2),
                                实钱赢家数占比: item.money_win_rate.toFixed(2)
                            }
                            let data3 = {
                                time,
                                活跃人数: item.active_user_num,
                                转入人数: item.pay_user_num
                            }
                            let data4 = {
                                time,
                                营收arpu: this.getCustomFixed(item.active_user_num ? item.new_win_sum / item.active_user_num / 10000 : 0),
                                ARPPU: this.getCustomFixed(item.pay_ave / 10000)
                            }
                            list[0].push(data)
                            list[1].push(data1)
                            list[2].push(data2)
                            list[3].push(data3)
                            list[4].push(data4)
                        }
                        this.updateVeline(list)
                    })
                })
            })

            let params1 = this.copyData(params) //代理拉新
            params1.param._func = 'GetTaxUserInfo'
            let params2 = this.copyData(params) //新增转入
            params2.param._func = 'GetNewPlatfromNewPayInfo'
            let params4 = this.copyData(params) //赠送详情
            params4.param._func = 'GetNewPlatformGiveData2'
            let params7 = this.copyData(params) //转入留存
            params7.param._func = 'GetNewPlatformRepeatPayInfo'
            let params8 = this.copyData(params)
            params8.param._func = 'GetNewPlatformRmbPlayerAveData'

            let arr = [params, params1, params2, params4, params7, params8]
            this.calcMap = {}
            this.timestamp = timestamp
            for (let i = 0; i < arr.length; i++) {
                if (i == 0) {
                    await this.http(i, arr[i], dateMap)
                } else {
                    this.http(i, arr[i], dateMap)
                }
            }
        },
        async http(index, httpParam, dateMap) {
            await new Promise((resolve, reject) => {
                httpParam.param._param.stime = dateMap.tStime
                httpParam.param._param.etime = dateMap.tEtime
                TransTopReq(httpParam).then((res) => {
                    let data = {}
                    if (index == 5) {
                        let pay_sum = this.table.data[0]['pay_sum_id']
                        let r_pay_sum = parseFloat(res._param.pay_ave) || 0
                        data = {
                            r_pay_sum,
                            r_pay_rate: pay_sum ? r_pay_sum / pay_sum : 0
                        }
                    } else {
                        data = res._param.data[0] || {}
                    }
                    data.type = 0
                    data.date_title = '当日'
                    this.reCalcValue(index, data, 0)
                    httpParam.param._param.stime = dateMap.yStime
                    httpParam.param._param.etime = dateMap.yEtime
                    TransTopReq(httpParam).then((res1) => {
                        let data1 = {}
                        if (index == 5) {
                            let pay_sum = this.table.data[1]['pay_sum_id']
                            let r_pay_sum = parseFloat(res1._param.pay_ave) || 0
                            data1 = {
                                r_pay_sum,
                                r_pay_rate: this.calcRate(r_pay_sum, pay_sum)
                            }
                        } else {
                            data1 = res1._param.data[0] || {}
                        }

                        this.reCalcValue(index, data1, 1)
                        this.getCalcResult(data1, data, 1)
                        data1.type = 1
                        data1.date_title = '环比昨日'
                        httpParam.param._param.stime = dateMap.wStime
                        httpParam.param._param.etime = dateMap.wEtime
                        TransTopReq(httpParam).then((res2) => {
                            let data2 = {}
                            if (index == 5) {
                                let pay_sum = this.table.data[2]['pay_sum_id']
                                let r_pay_sum = parseFloat(res2._param.pay_ave) || 0
                                data2 = {
                                    r_pay_sum,
                                    r_pay_rate: pay_sum ? r_pay_sum / pay_sum : 0
                                }
                            } else {
                                data2 = res2._param.data[0] || {}
                            }
                            this.reCalcValue(index, data2, 2)
                            this.getCalcResult(data2, data, 2)
                            data2.type = 2
                            data2.date_title = '同比上周'
                            httpParam.param._param.stime = dateMap.mStime
                            httpParam.param._param.etime = dateMap.mEtime
                            TransTopReq(httpParam).then((res3) => {
                                let data3 = {}
                                if (index == 5) {
                                    let pay_sum = this.table.data[3]['pay_sum_id']
                                    let r_pay_sum = parseFloat(res3._param.pay_ave) || 0
                                    data3 = {
                                        r_pay_sum,
                                        r_pay_rate: this.calcRate(r_pay_sum, pay_sum)
                                    }
                                } else {
                                    let result = res3._param.data || []
                                    for (let key in result[0]) {
                                        data3[key] = 0
                                    }
                                    result.forEach((item) => {
                                        for (let key in res3._param.data[0]) {
                                            if (!key.includes('_id')) {
                                                if (key.includes('_num') || key.includes('_sum') || key == 'pay_ave') {
                                                    data3[key] += item[key]
                                                } else if (key.includes('_rate')) {
                                                    data3[key] = res3._param[key] || 0
                                                }
                                            }
                                        }
                                    })
                                    for (let key in res3._param.data[0]) {
                                        if ((!key.includes('_id') && key.includes('_num')) || key.includes('_sum') || key == 'pay_ave') {
                                            data3[key] = data3[key] / result.length
                                        }
                                    }
                                    this.reCalcValue(index, data3, 3)
                                    if (index == 2) {
                                        data3.new_ci_ri_pay_rate = this.calcRate(data3.ci_ri_pay_num, data3.new_user_pay_num)
                                    } else if (index == 4) {
                                        data3.ci_ri_pay_rate = this.calcRate(data3.ci_ri_pay_num, data3.user_pay_num)
                                        data3.ci_ri_login_rate = this.calcRate(data3.ci_ri_login_num, data3.user_pay_num)
                                    } else if (index == 1) {
                                        data3.zhuan_rate = this.calcRate(data3.new_pay_user_num, data3.new_user_num)
                                    }
                                }
                                this.getCalcResult(data3, data, 3)
                                data3.date_title = '同比上月日均'
                                data3.type = 3
                                let arr = [data, data1, data2, data3]
                                if (this.timestamp == httpParam.timestamp) {
                                    if (index == 0) {
                                        this.table.data = arr
                                    } else if ([1, 2, 3, 4, 5].includes(index)) {
                                        for (let i in this.table.data) {
                                            let item = this.table.data[i]
                                            let el = arr[i]
                                            if (index == 1) {
                                                item.pid_num = el.pid_num
                                                item.all_money = el.all_money
                                                item.first_pay = el.first_pay
                                            }
                                            if (index == 2) {
                                                item.new_ci_ri_pay_rate = el.new_ci_ri_pay_rate
                                            }
                                            if (index == 3) {
                                                item.c_give_pay_sum = el.c_give_pay_sum
                                                item.pay_online_sum = el.pay_online_sum
                                                item.jackpot_pay_rate = el.jackpot_pay_rate
                                            }
                                            if (index == 4) {
                                                item.ci_ri_pay_rate = el.ci_ri_pay_rate
                                                item.ci_ri_login_rate = el.ci_ri_login_rate
                                            }
                                            if (index == 5) {
                                                item.r_pay_sum = parseFloat(el.r_pay_sum)
                                                item.r_pay_rate = el.r_pay_rate
                                            }
                                        }
                                    }
                                    this.table.data = this.copyData(this.table.data)
                                }
                                resolve(true)
                            })
                        })
                    })
                })
            })
        },
        //获取平台对比数据
        getComparedData() {
            TransTopReq(
                this.getTransTopParams('GetNewPlatfromData2', {
                    platid: this.table.params.platid,
                    app_id: this.table.params.app_id,
                    stime: this.getSecond(this.table.params.dataTime) - 24 * 60 * 60,
                    etime: this.getSecond(this.table.params.dataTime, false) - 24 * 60 * 60,
                    general: -1,
                    pack_no: -1
                })
            ).then((res) => {})
        },
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                timestamp: param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        },

        updateVeline(list) {
            this.table.list[6].data[0].data.rows = list[0]
            this.table.list[6].data[1].data.rows = list[1]
            this.table.list[6].data[2].data.rows = list[2]
            this.table.list[6].data[3].data.rows = list[3]
            this.table.list[6].data[4].data.rows = list[4]
            this.table.list[6].data.forEach((item) => {
                this.$refs[item.ref][0].echarts.resize()
            })
        },
        calcRateItem(val) {
            return (Math.round(val * 10000 || 0) / 100).toFixed(2)
        },
        rColItem(h, params) {
            let field = params.column.key
            let value = params.row[field]
            let color = this.rCol(params.row.type, value)
            let icon = this.getTrendIcon(h, params.row.type, value)
            if (field.includes('_sum') || field == 'pay_ave') {
                return h('div', [h('span', { style: { color } }, this.getCustomFixed(value / 10000)), icon])
            } else if (field.includes('_rate') && field != 'bet_pay_rate') {
                return h('span', [h('span', { style: { color } }, this.calcRateItem(value) + '%'), icon])
            } else {
                return h('span', [h('span', { style: { color } }, this.getCustomFixed(value)), icon])
            }
        },
        rCol(type, num) {
            if (type != 0) {
                if (num > 0) {
                    return '#32CD32'
                } else if (num == 0) {
                    return '#333'
                } else if (num < 0) {
                    return 'red'
                }
            } else {
                return '#333'
            }
        },
        toPdf() {
            this.table.name = Object.keys(this.table.list)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        reCalcValue(type, data, index) {
            switch (type) {
                //平台数据
                case 0:
                    let num1 = data.new_user_num
                    let num2 = data.new_user_pay_num
                    if (num1 && num2) {
                        data.new_user_rate = num2 / num1
                    }
                    data.pay_sum_id = data.pay_sum
                    //线上转入成功率
                    data.online_pay_rate = this.calcRate(data.online_pay_success_num, data.online_pay_all_num)

                    //佣金转入比
                    data.m_moeny_loss_rate = this.calcRate(data.send_total_percent_sum, data.pay_sum)
                case 1:
                    break
                case 2:
                    data.new_ci_ri_pay_rate = data.ci_ri_pay_rate
                    break
                case 3:
                    let from = this.table.data[index]
                    data.c_give_sum = data.give_sum
                    data.c_give_pay_sum = data.give_pay_sum
                    data.pay_online_sum = data.c_give_sum - data.c_give_pay_sum
                    data.jackpot_pay_rate = from && this.calcRate(data.c_give_sum, from.pay_sum_id)
                    break
                default:
                    break
            }
        },
        getTrendIcon(h, type, value) {
            if (type == 0 || !value) return
            return h('Icon', {
                props: {
                    type: value < 0 ? 'md-arrow-down' : 'md-arrow-up',
                    color: value < 0 ? 'red' : '#32CD32',
                    size: 16
                },
                style: {
                    marginLeft: '4px'
                }
            })
        },
        //新值data2 对比值data1
        getCalcResult(data2, data1, index) {
            for (let key in data2) {
                if (typeof data2[key] == 'number' && !key.includes('_id') && (!this.calcMap[key] || !this.calcMap[key].includes(index))) {
                    this.calcMap[key] = this.calcMap[key] || []
                    this.calcMap[key].push(index)
                    data2[key] = data1[key] - data2[key]
                    if (key == 'send_percent_num' && data1[key] == -1) {
                        data2[key] += 1
                    }
                }
            }
        },
        getColumnFirst() {
            return {
                title: '对比',
                key: 'date_title',
                align: 'center',
                width: 90,
                renderHeader: (h, params) => {
                    return this.renderHeader(h, '对比', '环比昨日=当天-昨日，同比上周=当天-上周同天，同比上月=当天-上月均值')
                }
            }
        }
    }
}
</script>

<style scoped lang="less"></style>
